import * as React from "react";
import { ClipboardCheck, Flame, Wrench, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Structural Alignment",
  description: "We identify biomechanical imbalances and spinal misalignments that may be causing persistent discomfort or restricted movement in your daily life.",
  icon: Wrench,
  href: "/ConditionsPage"
}, {
  title: "Neurological Vitality",
  description: "Our assessment locates areas of nerve interference, ensuring your brain and body communicate at peak efficiency for optimal systemic health.",
  icon: Flame,
  href: "/TreatmentsPage"
}, {
  title: "Personalized Strategy",
  description: "Gain a clear, evidence-based understanding of your health status and a tailored recovery strategy designed for lasting wellness and vitality.",
  icon: ClipboardCheck,
  href: "/HealthInsightsPage"
}];
export default function ServiceCards() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="38809" id="what-you-will-discover" ref={ref} className={`py-16 md:py-24 bg-[#F8F8F6] text-foreground transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, i) => <Card key={i} data-index={i} className="flex flex-col h-full bg-white/40 backdrop-blur-md text-foreground border border-white/60 rounded-[16px] shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300">
              <CardHeader className="pb-2">
                <div className="mb-4 inline-flex items-center justify-center size-12 rounded-lg bg-[#3B8FD4]/10 text-[#3B8FD4]">
                  <service.icon className="size-6 stroke-[1.5]" />
                </div>
                <CardTitle className="text-xl md:text-[1.25rem] font-sans font-semibold tracking-tight">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <p className="text-muted-foreground font-sans leading-relaxed">
                  {service.description}
                </p>
              </CardContent>
              <CardFooter className="pt-4">
                <Button asChild variant="outline" className="w-full sm:w-auto border-[#3B8FD4]/20 text-[#3B8FD4] hover:bg-[#3B8FD4]/5 hover:text-[#3B8FD4] hover:border-[#3B8FD4]/40 rounded-full transition-colors">
                  <Link to={service.href}>
                    Learn More
                    <ArrowRight className="ml-2 size-4" />
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}